export function humanBaseSize(bases: number): string {
  const thresh = 1000;
  if (Math.abs(bases) < thresh) {
    return `${bases}`;
  }
  const units = ["Kb", "Mb", "Gb"];
  let u = -1;
  do {
    bases /= thresh;
    ++u;
  } while (Math.abs(bases) >= thresh && u < units.length - 1);
  return bases.toFixed(1) + " " + units[u];
}
